export default {
  "alert.next.anyway": "PROCEED ANYWAY",
  "alert.cancel.giveup": "DISCARD",
  common_go_bind: "Bind",
  network_error: "Network error",
  trade_buy: "Buy",
  trade_sell: "Sell",
  trade_available: "Available balance:",
  trade_volume: "Volume:",
  trade_tip_input_price: "Please input price",
  trade_tip_input_quantity: "Please input quantity",
  trade_tip_balance_insufficient: "No enough balance",
  trade_create_order_quote_not_enough: "Failed to create order, because the required balance is greater than your available balance.",
  trade_create_order_base_not_enough: "Failed to create order, because your selling quantity is greater than your available balance.",
  trade_create_order_insufficient_balance: "No enough balance to create order.",
  trade_create_order_less_than_min_quantity: "The quantity is less than the required minimum limitation",
  trade_create_order_exceed_max_quantity: "The quantity exceeds the maximum allowed quantity",
  trade_create_order_low_amount: "Failed to create. The minimum required amount is {amount}",
  trade_create_order_low_price: "Failed to create. The minimum required price is {price}",
  trade_create_order_low_cost: "Failed to create. The minimum required balance is {cost}",
  trade_create_order_unresolved_error: "Failed to create. Unknown error:{data}",
  trade_create_order_get_apikey_failed: "Failed to get API Key",
  trade_order_volume_little_than_market_min: "The quantity you input is less than the minimum trading required quantity {min_quantity}",
  trade_grid_get_current_price_failed: "Failed to get current price",
  trade_pool_copy_confirm_tip: "The minimum balance to run this grid bot is {min_quantity}",
  trade_grid_check_error_price_range: "Invaid price range. Rules: Stop-loss price < Support price (Lower limit price) < Resistance price (Upper limit price)",
  trade_grid_check_error_price_empty: "You need to input the price range",
  trade_grid_check_error_grids_count_empty: "You need to input the grid count",
  trade_grid_check_error_price_stop: "Stop-loss price can't be higher than current price",
  trade_bot_no_ai_main_title: "NO AI strategy for this trading pair",
  trade_bot_no_ai_main_sub_title: "Please tap SET MYSELF to set the parameters.",
  grid_order_create: "Create",
  grid_order_high: "Upper limit price",
  grid_order_low: "Lower limit price",
  grid_balance_need: "Required balance",
  gird_row_count: "Grids quantity",
  grid_transaction: "Transactions",
  grid_per_volume_get_error: "Please input quantity per grid",
  grid_param_wrong: "Wrong parameters. Rules: Stop-limit price< Lower limit price< Upper limit price!",
  grid_row_wrong: "Grids quantity should be between 2 and 150. Please modify and create the bot again",
  grid_err_error_none_balances_go: "Failed to get balance",
  grid_err_error_in_get_balance: "Error occurred when getting balance",
  grid_stop_high_ticker: "Stop-limit price should be less than current price",
  grid_dialog_title: "Tips",
  grid_dialog_content: "In order to start grid bot, you need to buy {baseInfo} first. We will buy it for you with the current optimal price after you have confirmed.",
  grid_dialog_content_1: "In order to start grid bot, you need to sell about {baseInfo}. We will sell it for you with the current optimal price after you have confirmed.",
  grid_trade_same_price: "The grids quantity you set is too high. Please decrease and then try again.",
  price_line_type_7d: "7D",
  price_line_type_30d: "30D",
  price_line_type_180d: "180D",
  grid_ai_count: "Grids",
  ai_rather_than_95_warning: "Please set the investment less than 95%",
  trade_balance_no_result: "Failed to get balance.",
  trade_balance_loading: "Loading balance now...",
  grid_param_err: "Invalid grid parameters",
  order_create_success: "Created successfully",
  button_ok: "OK",
  button_cancel: "Cancel",
  button_confirm: "Confirm",
  trailing_stop_limit_have_no_base: "HAVE NO {base}",
  trailing_stop_limit_have_base: "I HAVE {base}",
  trailing_stop_limit_place_holder_buy_price: "Buy price(limit order)",
  trailing_stop_limit_place_holder_trailing_percent: "Trailing percent",
  trailing_stop_limit_button_have_base: "TAKE PROFIT",
  trailing_stop_limit_button_have_no_base: "BUY & TAKE PROFIT",
  trailing_take_profit: "TRAILING TAKE PROFIT",
  trailing_stop_limit_order_trigger_price: "Trigger price",
  trailing_stop_limit_order_trailing_percent: "Trailing percent",
  trailing_stop_limit_order_buy_quantity: "Buy quantity",
  trailing_stop_limit_order_sell_quantity: "Sell quantity",
  trailing_stop_limit_error_input_buy_price: "Please input buy price(limit price)",
  trailing_stop_limit_error_input_trigger_price: "Please input trigger price",
  trailing_stop_limit_error_input_trailing_percent: "Please input trailing percent",
  trailing_stop_limit_error_input_quantity: "Please input quantity",
  trailing_stop_limit_recommend_trailing_percent: "The Trailing percent you set is too big. We suggest you to set less than 10%",
  order_status_canceling: "Cancelling",
  order_trigger_price: "Trigger price",
  order_trigger_sell_price: "Sell price",
  order_trigger_buy_price: "Buy price",
  grid_request_error_grid_price_hit_price_min: "The price you set is far away from the current price so that we can't place order. Please reset the price and create the bot again",
  grid_err_error_per_volume_hit_amount_min: "The buy quantity per grid is less than the required minimum quantity. Please reset and create the bot again.",
  grid_err_error_grid_cost_hit_cost_min: "The buy quantity per grid is less than the required minimum quantity. Please reset and create order again.",
  grid_err_error_balance_not_enough_quote: "You don't have enough balance. Please decrease the grids quantity or buy quantity per grid, or buy additional {{quote}}，until available balance is greater than required balance, and then create order.",
  grid_err_error_balance_not_enough_base: "You don't have enough balance. Please decrease the grids quantity or buy quantity per grid, or buy additional {{base}}，until available balance is greater than required balance, and then create order.",
  grid_err_error_balance_not_enough_both_side: "You don't have enough balance. Please decrease the grids quantity or buy quantity per grid, or buy additional {{base}} or {{quote}}，until available balance is greater than required balance, and then create order.",
  grid_err_error_manual: "Unknown error",
  grid_err_error_in_place_grid_balance_order: "Failed to create grid trading order",
  grid_err_error_in_wait_sell_grid_balance: "Failed to create grid trading order",
  grid_err_error_in_grid_stop_loss: "Failed to create grid trading order",
  grid_err_error_in_cancel_orders: "Failed to cancel grid trading order",
  grid_err_error_in_place_grid_orders: "Failed to create grid trading order",
  grid_err_error_in_wait_order_done: "Failed to create grid trading order",
  grid_err_error_got_none_check_grids: "Failed to create grid trading order",
  grid_err_error_not_found_cross_order: "Failed to create grid trading order",
  grid_err_error_got_none_cb_info: "Failed to create grid trading order",
  grid_err_error_got_unknown_cb_action: "Failed to create grid trading order",
  grid_err_error_add_not_balanced_monitor_error: "Failed to create grid trading order",
  grid_err_error_add_balanced_monitor_error: "Unknown error. Please try again later or get contact with our technical support in the telegram group.",
  grid_err_error_balance_not_enough_in_run_time: "You don't have enough balance to continue",
  grid_err_error_got_unknown_order_id: "Failed to get orders",
  grid_err_error_stop_in_loss: "Failed to create stop-loss order",
  grid_error_price_is_too_broad: "Price range is too wide",
  grid_error_exchange_busy: "Cannot create order because the exchange is busy now. Please wait for a while and retry.",
  grid_error_sign_failed: "Cannot create order because your API Key is invalid. Please check if you restricted the IP or your API has expired. Please change the settings or create a new API Key and retry.",
  grid_create_error_has_pending: "Please wait until another order has been created already.",
  grid_create_error_too_many_micro_order: "Failed to create the order for the restriction of exchanges. You cannot create more than 2 orders of which the investment is less than 1000 USD for one trading pair.",
  grid_create_error_too_many_row: "Failed to create the order because of the restriction of the exchange max orders limitation.",
  grid_create_error_too_many_one_key: "You can only create no more than 5 grid trading orders using the same API Key.",
  annualized_return: "Annualized",
  header_pair: "PAIR",
  gridtrading_return: "Backtesting annualized return (7D)",
  igTrading_return: "Backtesting annualized return (30D)",
  // 新增
  use_ai_STRATEGY: "Use AI strategy",
  set_myself: "Customize",
  price_range: "Price range",
  done: "DONE",
  "balance.table.coin": "Coin",
  "withdraw.confirmation.confirm": "CONFIRM",
  balance_coin_select_title: "Choose coin",
  order_title_investment: "Investment",
  order_cancel_text: "CANCEL",
  "general.tips": "Tips",
  strateg_Investment_Frequency: "Investment frequency",
  strateg_Sec: "Sec",
  strateg_Min: "Min",
  strateg_Hour: "Hour",
  strateg_Day: "Day",
  strateg_Week: "Week",
  strateg_Month: "Month",
  strateg_Investment_per_week: "Investment per week:",
  gridtrading_Profit: "Profit per grid",
  trading_investement: "Investment",
  strateg_Deposdt_usdt: "DEPOSIT USDT",
  trading_aip_usdt_not_enough: "You don't have enough USDT to start the DCA. Please deposit some or swap some of your coins to be USDT first.",
  aip_investment_per_time: "Investment each time (required ≥ {value})",
  aip_investment_per_volume_null: "Please input investment each time",
  aip_create_order_get_current_symbol_failed: "Failed to get current trading pair's data",
  aip_per_volume_small_than_min_cost: "The input quantity doesn't match the minimum required quantity.",
  aip_button_start: "START",
  aip_profit_time: "Return of DCA from {time}",
  aip_balance_not_enough_to_spend_a_week: "Your available balance is not enough for 1 week of DCA, please deposit more or decrease your investment per week.",
  bot_trading_investment_hint_title: "Hint: The bot will lock investment for a week once a time",
  volume_label_short: "Vol:",
  market_order_not_support: "This exchange doesn't support market order",
  grid_current_price: "Current Price",
  trading_twap_buy_quantity_low: "The minimum investment quantity each time is {min}{quote}. Please decrease the buy period or increase your total investment to {total}{quote} first",
  trading_twap_sell_quantity_low: "The minimum sell quantity each time is {min}{base}.Please decrease the buy period",
  trading_twap_total_investment_null: "Please input the total investment of TWAP",
  trading_twap_buy_cost_per_time_label: "Buy quote each time",
  trading_twap_sell_quantity_per_time_label: "Sell quantity each time",
  trading_twap_balance_not_enough: "Haven't enough minimum transaction amount.",
  twap_sell_all_invest: "Total sell quantity",
  twap_buy_all_invest: "Total investment",
  twap_buy_rate_title: "How often to buy",
  twap_sell_rate_title: "How often to sell",
  ig_trading_lower_price: "Lower limit",
  ig_trading_profit_per_rate_placeholder: "Profit per grid({min}-10% required)",
  ig_trading_investment: "Total investment",
  trade_create_order_get_price_failed: "Failed to create the bot because of not able to get price from server.",
  trade_create_order_get_order_book_failed: "Failed to create the bot because of not able to get data from the orderbook.",
  IG_INSUFFICIENT_INVEST_ERROR: "Your investment doesn't meet the minimum requirement (≥{min})",
  IG_INSUFFICIENT_FUNDS_ERROR: "You don't have enough balance, which is required to be greater than {min}",
  IG_BAD_BALANCE_ORDER: "The total investment amount exceeded the maximum limit, please reduce the total investment by 10%-30%",
  ig_trading_out_of_bounds_error: "You don't have enough balance to create the bot. Please increase the lowest price or deposit some coins first.",
  ig_trading_please_input_bottom: "Please input lowest price.",
  ig_trading_please_input_investment: "Please input total investment.",
  ig_trading_please_input_rate: "Please input profit per grid.",
  ig_trading_rate_range_error: "Profit per grid should be between 0.1%-10%",
  ig_trading_loading: "Loading...",
  trading_invest_need_more_than: "should ≥ {invest}",
  rules: "Rules",
  coin_cap_search_place_holder: "Search coin name",
  order_profit_modal_recommend_text: "(Recommended)",
  error_grid_low_price_is_too_low: "You can't start this bot because your support price is far lower than current price, please check and reset.",
  error_grid_high_price_is_too_high: "You can't start this bot because your resistance price is far higher than current price, please check and reset.",
  account_kyc: "KYC",
  account_nickname_not_set_tip: "Username not set",
  search_result_no_data: "No coin found.",
  grid_param_invest_earn: "Invest & earn",
  trade_profit_per_grid: "Profit per grid",
  grid_param_stop_loss: "Stop loss price",
  grid_pro_fluctuan_bullish: "Fluctuant and then bullish",
  grid_pro_fluctuan_bearish: "Fluctuant and then bearish",
  gridPro_submintbutton: "Create",
  pro_partial_model_cancel: "CANCEL",
  pro_partial_model_continue: "CONTINUE",
  pro_partial_model_Range: "Range",
  pro_partial_model_ProfitGrid: "Profit per grid",
  pro_partial_model_Investment: "Investment",
  gridsAddonAfter: "Grids",
  informationModel_buttonGoit: "GOT IT",
  trade_total_investment: "Total investment",
  market_trading_big_amount_warning: "Hint",
  market_trading_big_amount_warning_desc: "The placed volume is very big and it might cause a dip and make you lose. Please reset the order or we recommen you to use limit orders.",
  still_continue: "PROCEED ANYWAY",
  create_order_repeat: "DISCARD",
  grid_pro_order_FillHistory_QuantityGrid: "Quantity/grid:",
  prolist_stop_loss: "Stop loss",
  prolist_take_profit: "Close bot at",
  grid_profit_rate: "Profit/grid",
  pro_partial_model_title: "Confirmation",
  pro_partial_model_InvestEarn: "Invest & Earn ",
  pro_partial_model_GridsNumber: "Grids number",
  trading_stop_loss_price: "Stop loss price",
  trading_stop_profit_price: "Take profit price",
  holder_LowerPricePlaceholder: "Lower limit",
  holder_UpperPriceplaceholder: "Upper limit",
  informationModel_title: "Please input the following parameters",
  trade_invest_range_min: "≥ {min} required",
  trade_invest_range_available: "Available balance",
  trading_total_investment: "Total investment",
  text_bullish: "bullish",
  text_bearish: "bearish",
  gird_price_range_error: "Upper limit should be higher than lower limit",
  grid_bullish_take_profit_error: "Take profit price should be higher than upper limit, current price and trigger price",
  grid_bullish_stop_loss_error: "Stop loss price should be less than lower price current price and trigger price",
  grid_bealish_take_profit_error: "Take profit price should be less than bottom price current price and trigger price",
  grid_bealish_stop_loss_error: "Stop loss price should be greater than upper limit current price and trigger price",
  grid_transaction_detail_fee_deduct: "Fee deducted",
  INSUFFICIENT_INVEST: "The investment is lower than required.",
  trade_error_input_price: "Please input price.",
  trade_error_input_quantity: "Please input quantity.",
  trade_error_balance_not_enough: "No enough balance.",
  trade_error_unknown: "Unknown error",
  trade_error_price_too_low: "Failed to create order. The lowest price is {price}",
  trade_error_price_too_high: "Failed to create order. The highest price is {price}",
  trade_error_low_cost: "Failed to create order. The minimum required volume is {cost}",
  trade_error_low_amount: "Failed to create order. The minimum required quantity is {amount}",
  trade_create_order_success: "Created successfully.",
  trade_grid_ai_percent_95: "Please set the investment no bigger than 95%",
  trade_error_grid_ai_params_wrong: "AI strategy error",
  trade_error_grid_low_need_lower_than_high: "The lowest price should be lower than the highest price",
  market_label2: "Bullish",
  gird_loan_trend_short_desc: "Lock your {quote} to loan {base} for the Bot. Earn {quote} when {base} goes down",
  gird_loan_trend_long_desc: "Lock your {base} to loan {quote}. Earn {base} when {base} goes up",
  credit_coin_name: "Loan {coinName}",
  trade_borrowable_invest: "Borrowable fund",
  daily_interest: "Current daily interest",
  grid_liquidation_price: "Estimated liquidation price",
  credit_grid_leverage: "Leverage",
  drawer_leverage_unavailable_desc: "The current pair doesn't support Leveraged or Margin grid bot. Please choose from the below pairs with a icon like 3x",
  trade_leverage_invest: "Leveraged investment",
  balance_own: "Own",
  balance_borrow: "Borrow",
  trade_invest_desc: "Investment allocation",
  grid_balance_available_max: "Max investment",
  trade_pledge_invest: "Margin",
  trade_max_pledge_available: "Available margin",
  trade_loaned: "Loan",
  trade_input_optional: "Optional",
  trade_error_condition_need_greater_than: "Trigger price should be {rate} greater than the current price",
  trade_error_condition_need_less_than: "Trigger price should be {rate} smaller than the current price",
  lasting: "Lasting",
  grid_order_lasting_day: "d",
  grid_order_lasting_hour: "h",
  grid_order_lasting_minute: "m",
  trade_grid_per_volume: "Quantity per grid",
  trade_grid_balance_not_enough: "No enough balance",
  grid_balance_available: "Available Balance",
  update_time: "Update at{ time }",
  trade_exchange_fee: "Exchange fee",
  trade_grid_min_balance_tip: "The minimum balance to run this grid bot is {min}",
  trade_please_input_price_range: "Please input price range.",
  trade_error_input_grid_count: "Please input grids quantity.",
  trade_error_grid_count_range_error: "You can only set the grids quantity between 2 to 99. Please reset and create the order again.",
  waring: "Hint",
  trade_grid_balance_order_buy: "In order to create the trading bot, we will help to buy {info} first with the optimal price.",
  trade_grid_balance_order_sell: "In order to create the trading bot, we will help to sell {info} first with the optimal price.",
  trade_error_per_volume_hit_amount_min: "The quantity per grid you set is smaller than the requested minimum volume of the exchange. Please reset and then create order again.",
  trade_error_grid_price_hit_price_min: "The price you set is way off comparing to the current trading pair price. Please reset and then create order again.",
  trade_error_grid_price_too_small: "You can't start this bot because your support price is far lower than current price, please check and reset.",
  trade_error_grid_cost_hit_cost_min: "The quantity per grid you set is smaller than the required minimum volume of the exchange. Please reset and then create order again.",
  trade_grid_error_unknown: "Unknown error. Please try again later or get contact with the support team: https://t.me/pionexen",
  trade_error_duplicate_grid: "The grid quantity you set is too big, and we cannot divide so many grids in such a small price range. Please adjust the grid quantity and then create order again",
  trade_error_grid_exchange_busy: "Cannot create order because the exchange is busy now. Please wait for a while and retry.",
  trade_grid_error_sign_failed: "Cannot create order because your API Key is invalid. Please check if you restricted the IP or your API has expired. Please change the settings or create a new API Key and retry.",
  trade_grid_error_price_too_high: "You can't start this bot because your resistance price is far higher than current price, please check and reset.",
  gird_orders_count_no_more_than_two: "You can only create 2 bots with any trading pair",
  grid_future_has_same_symbol_opening_order: "You are already running a Futures Grid Bot, so you can not create another one.",
  symbol_not_support_trading: "This pair isn't supported for trading",
  daily_fund_fee: "Funding fee",
  sort_pair: "PAIR",
  trade_price_range: "Price range",
  trade_investment: "Investment",
  trade_leverage_rate: "Leverage",
  trade_loan_rate: "Leverage",
  trade_conditional: "Trigger price",
  trade_take_profit: "Close Bot at",
  trade_bot_can_not_open_more: "You can not create more bots with this pair",
  trade_bot_can_not_open_more_5_1_binance_desc: "Binance changed their API limitation that you can not place too many orders under one trading pair, so you can only create 2 bots with any trading pair. If you want to create more bots, you can have a try at Pionex. It has a built-in Grid Trading Pro bot. You can set up to 200 grids. The fee is only 0.05% and it also has Margin Grid Bot to help make more profits.",
  pionex_url_from_binance_max_2_bot_desc: "https://www.pionex.com/en-US?r=XxGvMPpl",
  transfer_profit_error_20002: "Releasing other profits. Please try again later.",
  transfer_profit_error_30003: "Invalid coin",
  transfer_profit_error_30004: "Invalid quantity",
  order_msg_user_cancel: "Manually cancelled",
  order_msg_profit_stop: "Auto took profit",
  order_msg_loss_stop: "Auto stopped loss",
  order_status_canceled: "Canceled",
  order_status_traded: "Traded",
  grid_bullish_take_profit_error_current_price: "CLOSE BOT AT price should be greater than current price",
  grid_bullish_stop_loss_error_current_price: "Stop loss price should be less than current price",
  grid_bealish_take_profit_error_current_price: "'CLOSE BOT AT price should be less than current price",
  grid_bealish_stop_loss_error_current_price: "Stop loss price should be greater than current price",
  trade_buy_price: "Buy price",
  trade_sell_price: "Sell price",
  trade_buy_amount: "Buy quantity",
  trade_sell_amount: "Sell quantity",
  advanced_settings: "Advanced settings",
  trade_params_not_fill_enough: "Please input all needed parameters",
  separate_row_wrong: "The order number should be between {min} and {max}",
  trade_bottom_need_lower_than_high: "Bottom price need lower than high price",
  price_is_not_in_range_on_limit: "Invalid price. It should be between {min} - {max}",
  stop_loss_is_not_in_range_on_limit: "Invalid stop loss price. It should be between {min} - {max}",
  take_profit_price_need_bigger_than_buy_price: "Take profit price should be higher than buy price",
  take_profit_price_need_bigger_than_stop_loss: "Take profit price should be higher than stop loss price",
  stop_loss_price_need_lower_than_buy_price: "Stop loss price should be lower than the buy price",
  trailing_percent_need_be_lower: "The trailing percent should be lower than {max}.",
  BAD_STRATEGY_PARAMETERS: "Invalid parameters. Please increase the bottom price or profit per grid.",
  take_profit_on_hight: "Take profit",
  stop_loss_on_low: "Stop loss",
  trade_take_profit_buy_market_order_desc: "We will sell your coins with market order. It's better not to use it in a low liquidity market to avoid loss.",
  trade_stop_loss_buy_market_order_desc: "We will sell your coins with market order. It's better not to use it in a low liquidity market to avoid loss.",
  trade_sell_triggle_price: "Trigger sell price",
  trade_max_trailing_percent: "Trailing percent",
  trade_no_use_set_zero: "set 0 if you want to disable it",
  trade_stop_loss: "Stop loss price",
  trade_current_button: "Current",
  trade_trailing_percent_range_error: "The trailing percent should be between {min} and {max}",
  trade_expected_vol_desc: "The expected volume is calculated using trigger price, and the final real volume might be different from this.",
  trade_error_high_amount: "Failed to create an order. The maximum quantity limitation is {amount}",
  order_status_error_appear: "Error occurred",
  grid_error_profit_per_grid_is_zero: "The current profit per grid is less than zero which can't make profits, please reduce the grid quantity",
  gridPro_err_error: "Unknown error",
  grid_pro_loss_stop: "Auto stopped loss",
  grid_pro_profit_stop: "Closing price reached",
  gridPro_err_force_liquidation: "The order is liquidated",
  not_enough_balance: "No enough balance",
  invalid_api_key: "Your API is invalid. Please check if you have disabled the permission or deleted it.",
  per_volume_hit_amount_min: "The investment should be greater than the minimum limit",
  cannot_reach_limit_open_price: "We have canceled the bot because we can not buy the coin under the price limit.",
  no_orderbook: "No orderbook",
  invalid_margin_type: "You have set the account as Cross mode. We can only create a bot under Isolated mode.",
  invalid_position_side: "You have set the position as Hedge mode. We can only create a bot under One-way mode.",
  position_not_matched: "We found you might have manually closed all positions, so we stopped the bot due to risk control.",
  leverage_not_matched: "We found you might have adjusted the leverage, so we stopped the bot due to risk control.",
  has_position_before_open: "You have position in this trading pair. Please create the bot after you have closed it.",
  not_managed_exchange_order: "We found you placed an order in this trading pair, so we stopped the bot due to risk control.",
  grid_profit_rate_less_than_fee_rate: "The profit per grid is too small to pay the transaction fees. To prevent you from losing money, we stopped the bot.",
  exchange_order_canceled_by_user: "We found you might cancelled some orders in this trading pair, so we stopped the bot due to risk control.",
  error_to_create_buy_order: "Failed to create the order.",
  error_to_create_sell_order: "Failed to create the sell order",
  Error_failed_to_lock_amount: "Failed to lock your balance",
  Error_failed_to_create_strategy: "Failed to create the bot",
  Error_failed_to_clear_strategy: "Failed to unlock your balance",
  Error_failed_to_allocate_strategy: "Failed to lock your balance",
  Error_failed_to_unlock_amount: "Failed to unlock your balance",
  Error_invalid_rpc_response: "RPC error",
  ERROR_BAD_BALANCE_ORDER: "Error occurred in the initial buying coins process",
  ERROR_OUT_OF_BOUNDS_ERROR: "Smaller than the minimum required volume",
  ERROR_CREATE_EXCHANGE_ORDER_FAILED: "Failed to create the bot",
  ERROR_CANCEL_EXCHANGE_ORDER_FAILED: "Failed to cancel the bot",
  ERROR_EXCHANGE_ORDER_STATUS_ERROR: "The order status is in error",
  ERROR_ADJUST_ORDER_FAILED: "Exceeds the maximum required volume",
  trade_invest_range_max: "Required ≤ {max}",
  trade_purchase_volume: "Investment",
  trade_espected_buy_in: "Estimated buy quantity",
  trade_trailing_buy_espected_volume_desc: "The estimated buy quantity is calculated by the trigger price, so the final buy quantity may be different from it because of the price fluctuation.",
  Error_admin_cancel: "This bot was cancelled by the system. Usually it is because the coin was split. You can check the announcement from the official website.",
  trade_all: "ALL",
  smart_trading_switch_limit: "Limit (Standard mode)",
  smart_trading_switch_market: "Market (Speed mode)",
  grid_err_error_none_balances_got: "Failed to get balance",
  trade_error_high_cost: "Failed to create the order. The max investment limit is {cost}",
  year_back_7: "7D APR",
  year_back_30: "30D APR",
  year_back_180: "180D APR",
  cross_time_price_offset_now: "Current price gap",
  trade_leverage_short: "Leverage",
  ct_arbitraging_choose_leverage_tip: "The higher the leverage is, the higher the profit is. But the Futures part will be easier to be liquidated. We will auto stop the Futures and sell the spot when it's near the liquidation price({liquidation_price} for this order). There will be trading fees and slippage.  \nRisk warning: Because Pionex Futures is powered by Binance Broker system, if Binance API is broken, there might be risk of losing your position.",
  trade_error_fsa_max_limit: "The total investment should be not more than {max}",
  smart_trade_market_error_symbol_max_dumping: "Due to the max trading quantity limit, please decrease the investment under {max}.",
  trade_choose_symbol_support_fsa: "Please first choose a coin",
  trade_error_query_fee: "Failed to get trading fee. Please check the network or re-open the bot. Error code: {error}",
  future_trade_error_had_fsa: "You have created an arbitrage bot, so you can not manually trade anymore before you close the bot.",
  fsa_error_had_order_already: "You can only create one bot with one trading pair",
  fsa_order_add_position_max: "Max available is {max}{quote}",
  fsa_order_add_position_20002: "Under adding/withdrawing investment, please try again later.",
  fsa_order_reduce_position_20002: "Under adding/withdrawing investment, please try again later.",
  trade_bot_can_not_open_more_reason: "{market} has restricted max orders quantity, so you can only create 2 bots at the same time. If you want to more , please use Pionex, whose fee is only 0.05%, aggregates liquidity from Binance and Huobi, and has 12 free bots.",
  future_spot_transfer_failed_cause_adjusting: "When the arbitrage bot is opening or closing, you can not do anything except for closing a position in Futures manual trading",
  future_spot_leverage: "{leverage}× leverage",
  future_spot_rate_title: "Funding fee after {time}",
  list_unfold: "Unfold",
  list_hidden: "Fold",
  fas_price_diff_contrl: "Price gap control(%)",
  future_spot_sort_by_annualized_7_days: "Sort by 7D APR",
  future_spot_sort_by_annualized_30_days: "Sort by 30D APR",
  future_spot_sort_by_annualized_180_days: "Sort by 180D APR",
  future_spot_sort_by_rate: "Sort by funding fee",
  has_open_orders_before_open: "You have placed orders in spot or futures market of this trading pair. Please cancel the orders and try again.",
  Error_invalid_argument: "Invalid parameters. ",
  fsa_order_auto_close: "When the coin price hits 5% away from the liquidation price of the futures part, we will auto stop the bot to take profit and avoid risk. We recommend you to use 2× or lower leverage",
  Error_transfer_error: "Failed to transfer funds",
  fsa_create_order_price_diff_too_low: "You can not set the gap lower than {min} to avoid a big loss.",
  order_status_auto_close: "Auto closed",
  Error_too_much_amount_profit_withDrawn: "Failed to release profit due to lacking funds.",
  Error_too_much_amount_margin_withDrawn: "Failed to withdraw margin due to lacking funds.",
  Error_too_much_amount_common: "No enough funds",
  Error_not_enough_balance_add_position: "Failed to add investment due to lacking funds.",
  Error_not_enough_balance_add_margin: "Failed to add margin due to lacking funds.",
  error_not_enough_loan_market: "The fund pool is empty now, so your bot was auto closed.",
  order_canceled_by_not_enough_loan_market: "No fund to lend",
  error_insufficient_funds: "No enough releasable funds",
  trade_error_symbol_is_banned: "This pairs is suspended for trading. Please check the announcement.",
  trade_error_symbol_invest_high: "The max total allowed investment for this pair is {max} USDT",
  trade_error_leveraged_coin_price_low: "Failed to buy. When the price of this pair has been less than 0.1, you can only sell.",
  trade_error_bot_order_can_not_more: "You can not create more tha {max} bots with the same trading pair.",
  grid_error_triggle_price_not_in_range: "Failed to create. The 「Create bot at」 price has exceeded the grid price range.",
  grid_error_current_price_not_in_range: "Failed to create. The grid price range should include the current market price.",
  INSUFFICIENT_FUNDS_ERROR: "The coin price fluctuates too wide, so the balance is not enough",
  fsa_error_no_position: "Failed to create the bot because the investment is too small",
  bot_error_opening_in_this_pair: "Error code -50002. Please try again later, or contact the support.",
  gird_params_need_great_than_zero: "Grid parameter should be greater than 0",
  future_order_liquidated: "Liquidated",
  fsa_risk_plan_link: "https://pionex.zendesk.com/hc/en-us/articles/360062079894-Pionex-s-Arbitrage-SAFU-Program",
  fsa_risk_security: "SAFU Program",
  had_join_fsa_risk_plan: "Joined SAFU Program",
  no_join_fsa_risk_plan: "Haven't joined SAFU Program",
  fsa_join_risk_plan_desc: "Current accumulative investment {total}/{max}, you will join SAFU Program automatically if the accumulative investment amount is beyond {max_short}. ",
  button_join_now: "Join Now",
  fsa_risk_fund_rules: "Detailed Rules for SAFU Program",
  fsa_risk_fund_rules_desc: "Users can apply for compensation when suffer unexpected losses",
  fsa_more_bub_title: "Earn more BUB",
  fsa_more_bub_title_desc: "Holding BUB and get discount",
  bot_error_50: "{symbol} is now under maintenance, so you can not trade order create a bot. Please pay attention to the announcement.",
  bot_error_49: "The market-making activities on trading pair {symbol} are temporarily suspended. Trading on this trading pair at this time might cause a considerable loss. Do you still want to create the bot now?",
  bot_error_49_title: "Probabe loss when creating",
  fsa_cancel_error_50: "{symbol} is now under maintenance, so it can not be traded. You can check the latest status in the announcement center.",
  fsa_join_risk_plan_error: "Failed to join Arbitrage SAFU. Please try again later or contact support. Error code: {error}",
  fsa_join_risk_plan_success: "Joined Arbitrage SAFU successfully",
  fsa_join_risk_plan: "Join Arbitrage SAFU",
  fsa_join_risk_plan_warning: "You are not able to quit after you have joined. Are you sure to join?",
  network_error_and_error: "Network error. Error: \n{error}",
  trade_error_market_spending_more: "You can place a order no more than {limit} once a time",
  leverage_stuck_jump_url: "https://pionex.zendesk.com/hc/en-us/articles/900007030803-Pionex-will-launch-2L-2S-leverage-tokens-to-replace-3L-3S-leverage-tokens",
  leverage_stuck_bot_title: "Can't create trading bot",
  leverage_stuck_manual_title: "Can't buy",
  leverage_stuck_bot_content: "This leverage token is risky and you can't create new trading bot. If you want to trade with leverage, please use 2L/2S leverage token instead.",
  leverage_stuck_manual_content: "This leverage token is risky and you can't buy manually. If you want to trade with leverage, please use 2L/2S leverage token instead.",
  leverage_stuck_trade_continue: "Trade {base}",
  leverage_stuck_list_show: "Get restricted list",
  trade_error_leveraged_bot_3x_stuck: "This leverage token is risky and you can't create new trading bot. If you want to trade with leverage, please use 2L/2S leverage token instead.",
  trade_error_leveraged_manual_3x_stuck: "This leverage token is risky and you can't buy manually. If you want to trade with leverage, please use 2L/2S leverage token instead.",
  trade_manual_leverage_amount_left: "Remaining quota",
  trade_manual_leverage_amount_left_desc: "As other users create or cancel order may occupy or release quota, and the leveraging or deleveraging of leverage token is limited by the Futures market and thickness of orderbook. The remaining quota may vary from time to time. ",
  trade_cost_than_leverage_amount: "The amount of leverage token you bought exceeds the remaining quota, which is {amount} USDT. Please reduce order quantity.",
  trade_cost_than_leverage_pair_limit: "The maximum manual holding amount of this leverage token is {amount} USDT. Please reduce order quantity or switch to other leverage tokens.",
  grid_count_range_wrong: "You can only set the grids quantity between {min}-{max}. Please reset and then create order again.",
  trade_error_fsa_max_limit_for_single_coin: "To control risk, the investment limit of {coin} is {value} {quote}",
  trade_error_investment_limit_exceeded: "Failed to create the bot. The max investment limit is {max}",
  /* 注册落地页end */
  chinese_mainland: "Mainland China",
  united_states: "the United States",
  leverage_coin_trading_country_disable_desc: "It's not allowed to trade leveraged tokens in {country} now",
  bot_trading_country_disable_desc: "It's not allowed to use {bot} bot in {country}",
  affiche_of_future_country_limit_link: "https://pionex.zendesk.com/hc/en-us/articles/900007639683",
  bot_trading_country_disable_ok: "YES",
  bot_trading_country_disable_details: "CHECK DETAILS",
  trading_double_coin_rebalance: "Dual-coin mode",
  trading_double_coin_rebalance_desc: "Simplified settings. HODL 2 valuable assets.",
  smart_rebalance_to_choose_coin: "Choose a coin",
  trade_spot: "Spot",
  trading_multi_coin_rebalance_desc: "Customized settings. HODL your own index.",
  add_a_new_coin: "Add new coins",
  max_coins_count_added_error_tip: "You can add at most {max} coins",
  trading_multi_coin_rebalance: "Multi-coins mode",
  smart_rebalance_leverage_coin_tip: "It's only allowed to choose BTC or ETH leveraged tokens.",
  bot_rebalance_multi_per_over_5: "Must greater than 5",
  sr_edit_percent_desc: "The sum of the percentages of each coin is not 100%, please balance the coin of the currency!",
  sr_edit_coin_count_alert: "Please select at least two coins!",
  sr_auto_percent_complete: "Click to auto balance",
  sr_select_coins: "{count}coins",
  sr_multi_max_coin_count: "You can only add 10 coins at most, you can delete some of them before adding!",
  smart_rebalance_per_label: "Investment Percentage",
  smart_rebalance_choose_coin_type_index: "Index",
  smart_rebalance_choose_coin_type_leverage: "Leveraged",
  top_cap_coin: "Topcap coins",
  other_coins: "Other coins",
  trade_loan_exceed_max_loan: "You can't borrow more than {max} from Pionex.",
  trade_loan_exceed_max_margin_percent: "To avoid risk, you can't mortgage more than {max} of your current asset.",
  trade_loan_exceed_max_loan_on_3x: "You can't borrow more than {max} from one 3x trading pair.",
  invalid_timestamp_check_time: "Invalid time-stamp, please make sure that your system is set to the automatic date & time.",
  tip_moon_bot_auto_use_mbtc: "When the investment is less than {invest}, we will auto use {mBase}  to create the bot, to increase the fund utilization rate. 1 {base} = 1,000 {mBase}",
  bot_trading_initial_allocation: "Initial allocation",
  params_confirmation_title: "Parameters confirmation",
  delete: "Delete",
  address_seletor_others_open: "Expand",
  address_seletor_others_close: "Close",
  rebalanced_bot: "Rebalancing Bot",
  trading_bot_advanced_slippage_title: "Slippage control",
  trading_bot_advanced_slippage_right: "Off",
  grid_type_title: "Grid mode",
  grid_geometric_interval: "Geometric",
  grid_arithmetic_interval: "Arithmetic",
  grid_invest_type_mode: "Investment",
  grid_invest_both_base_quote: "Both",
  grid_invest_only_quote: "{quote} Only",
  advanced_setting_slippage_content: "When you create a grid trading bot, due to the price change, your initial buy price might be higher and you may suffer a loss. You can set the initial price control limit to avoid big slippage.",
  advanced_setting_grid_content: "You can choose if you want to place the orders with arithmetic mode or geometric mode. Arithmetic mode means the price difference between grids are the same (like 1,2,3,4). Geometric mode means the price change between grids are the same in percentage (like 1,2,4,8). Arithmetic mode is more useful in a bullish market, while the geometric mode is more useful in a bearish market.",
  advanced_setting_invest_content: "You can choose if you want to only invest quote coin, or you want to invest both base and quote coins.",
  trade_copy_params_to_manual: "Copy parameters to Manual settings",
  reversed_trading_pair_title: "Reversed {base}/{quote} to {quote}/{base}",
  use_quote_instead: "Use {quote} instead",
  investment_low_use_MBTC_instead_tip: "The investment is small. We recommed you to switch {base} to {mBase}, which can provider better fund utilization rate. 1{base}=1000{mBase}",
  still_use_quote: "Still use {quote}",
  grid_create_order_big_invest_change_slippage_tip: "Your investment is big, we recommend you to set the slippage control as {value} to avoid loss.",
  yes_please_set_as: "Yes, Please set as {value}",
  no_keep_no_control: "No. Keep no control",
  sr_preset_index: "Index pool",
  sr_customize: "Customize",
  sr_choose_index_title: "Choose an index",
  sr_choose_an_index: "Choose an index",
  SRM_index_filter_trending: "Trending",
  SRM_index_filter_profit: "Most profitable (180D)",
  SRM_index_filter_publisher: "Latest published",
  sr_index_change: "Switch",
  sr_index_select: "Choose",
  sr_show_symbols: "More info",
  sr_advance_rebalance: "Rebalance",
  sr_advance_rebalance_mode: "Rebalance mode",
  switch_on: "On",
  switch_off: "Off",
  trigger_price_setting: "Set trigger price",
  sr_switch_periodic: "Periodic",
  sr_switch_threshold: "Threshold",
  sr_trigger_price_setting_desc: "You could set triger prices for one or more coins.\nThe bot will start running when any coin reached its trigger price",
  sr_rebalance_mode: "Rebalance mode",
  sr_rules_modify_by_time_interval_none: "Pause rebalancing",
  sr_rebalance_strategy_mode: "Rebalance every {value}",
  sr_enter_alert_trigger_threshold_desc: "Proportion deviated by {percent}",
  sr_rebalance_mode_desc: "The proportion of each coins will changed as the coin price goes up and down. The bot will have to sell the coin that increasing faster or decreasing lower and buy other coins to maintain the proportions. When rebalancing periodicly, the bot will check the proportion and rebalance after a fixed interval. When rebalancing by threshold, the bot will rebalance only when one of the coins of the portfolios crosses outside the bounds of their desired allocations ",
  smart_rebalance_coin_need_more: "You need at least choose {min} coins",
  sr_rules_modify_title: "Rebalance mode",
  sr_trade_content_1: "The bot will rebalance every {period} {time} to maintain the proportion of the coins. When one coin price is increasing faster or decreasing lower, the bot will sell it and buy the others. If the volume gap is lower than the minimum required trading volume, the bot will skip this time of rebalancing.",
  sr_trade_content_2: "The bot will rebalance to restore the preset proportion when the proportion of a certain coin derivated its target by {threshhold}. The bot will sell the coins which takes a larger proportion than its target proportion and buy the others.",
  smart_rebalance_percent_can_not_more_than_one: "The sum of proportions should =100%",
  sr_order_reduce_position_max: "Maximum withdrawable {max} {quote}",
  change: "Modify",
  trigger_price_min: "The trigger price needs to be greater than {min}",
  martingale_risk_preference: "Risk Preference",
  martingale_risk_preference_desc: "Please select the risk preference. The more aggressive the strategy, the higher the risk.",
  conventional_type: "Conservative",
  balanced_type: "Balanced",
  martingale_scale_type: "Price deviation mode",
  martingale_scale_type_desc: "Choose if you want the price that the bot will place an order to buy more coins scale in a percentage or a fixed number.",
  martingale_scale_type_percentage: "Percentage",
  martingale_scale_type_fix_number: "Fixed num",
  martingale_take_profit_ratio: "Take profit ratio",
  martingale_price_scale: "Price deviation",
  martingale_safety_orders: "Safety orders",
  number_input_range_error: "Please input an integer between {min} and {max}",
  martingale_take_profit_ratip_min_error: "Take profit ratio should be ≥ {min}",
  martingale_order_volume_scale: "Volume scale",
  martingale_order_volume_scale_edit_hint: "(1.0-2.0, one decimal)",
  martingale_order_trigger_price_tip: "The bot won't start working until the coin price reaches its trigger price.",
  martingale_order_safety_orders_tip: "This is the total number of safety orders the bot will place in each round. The more safety orders you set, the less amount in each buy order and the lower the price you can place an order.",
  martingale_order_volume_scale_tip: "In each round, the bot will buy the dips with each shares' investment scaled by this number. For example, if you set the volume scale as 2, the bot will buy the dip with 1, 2, 4, 8, 16... shares. The bigger the volume scale is, the smaller the max safety orders you can set.",
  martingale_order_total_invest_tip: "The total amount you want to invest",
  mtg_scale_exceed_current_price: "Price deviation cannot higher than the coin price",
  kyc_go_do: "Verify",
  cannot_create_manual_trade_desc: "Pionex has performed an account system upgrading, accounts without binding the email will not be able to placed buy orders. For your account's safety, please bind an email as soon as possible.\n How to bind the email: Account - Security - 2-Factor authentication - Email authentication",
  trade_profit_per_grid_no_fee: "Profit/grid (fee deducted)",
  trade_ig_ai_profit_per_grid: "Profit per grid (fee not deducted)",
  stop_opening_lower_price: "Stop opening lower limit",
  stop_opening_upper_price: "Stop opening upper limit",
  price_range_input_tips: "The bot will not start a new round if the current price is outside the price range.",
  price_range_input_upper_warnings: " The upper limit of the price range is much lower than the current price.  Are you sure you want to create the bot with these parameters?",
  price_range_input_lower_warnings: "The lower limit of the price range is much higher than the current price.  Are you sure you want to create the bot with these parameters?",
  price_range_confirm_upper_warnings: "The upper limit of the price range is much lower than the current price,  please make sure that you have input the correct parameter",
  price_range_confirm_lower_warnings: "The lower limit of the price range is much higher than the current price, please make sure that you have input the correct parameter",
  price_range_edit_params: "Edit price range",
  martingale_stop_loss_sheet_total_profit: "Total profit",
  martingale_stop_loss_sheet_unrealized_profit: "Unrealized profit",
  martingale_stop_loss_percentage_tip: "Tips : Your coins will be all sold when total profit hits the percentage , and the bot will be closed.",
  martingale_take_profit_percentage_tip: "Tips : Your coins will be all sold when your total profit hits that percentage , and the bot will be closed",
  martingale_stop_loss_unrealized_percentage_tip: "Tips: Your coins will be sold out, and the bot will be closed when the unrealized profit rate reaches the percentage. If you want to input a positive number, the number should be less than the current unrealized profit.",
  martingale_stop_loss_unrealized_percentage_editing_tip: "Tips: Your coins will be sold out, and the bot will be closed when the unrealized profit rate reaches the percentage.",
  martingale_stop_loss_percentage: "Stop loss percentage",
  martingale_take_profit_percentage: "Take profit percentage",
  martingale_take_profit_percentage_hint: "Percentage(>{percent}, one decimal)",
  martingale_stop_loss_percentage_hint: "Percentage ({range}, one decimal)",
  profit_ratio: "Profit",
  mtg_current_pnl: "Unrealized profit",
  require_smaller_than_upper_price: "Require＜upper price",
  enter_a_valid_number: "Please enter a valid number",
  fsa_other_coin_invest_limit: "Investing with altcoins might provides higher yield than topcoins, but with corresponding risks to your invested principle. ",
  fsa_other_coin_high_risk_tip: "To decrease your risk in financial management, 3x leverage is forbidden when arbitrage with altcoins.",
  martingale_stop_loss_percentage_editing_hint: "Stop loss percentage（one decimal, optional）",
  modify_stop_loss_max_error: "Stop loss percentage should ＜{percent}",
  modify_stop_loss_min_error: "Stop loss percentage should ＞-100",
  modify_stop_profit_max_error: "Stop loss percentage should ＞{percent}",
  martingale_stop_loss_percentage_range_hint: "Stop loss percentage （0-100，one decimal）",
  martingale_error_action_not_in_range: "Failed to operate, the current price is out of the price range.",
  symbol_under_maintenance_cannot_trade: "The trading pair is under maintenance at this time,  please try again later.",
  trade_error_fsa_total_investment_alt_coin: "Cannot invest over accumulated {max}USDT on altcoins",
  trade_error_fsa_single_coin_investment_alt_coin: "Cannot invest over {max}USDT on a single altcoin",
  trade_error_fsa_total_investment_whole_net: "No remaining quota on this coin.",
  transfer_profit_error_30002: "There are outstanding operations running，please try again later",
  fm_arbitrage_expect_apr: "APR",
  fm_arbitrage_error_40300991: "Operation failed. The token is under maintenance. Please try again later.",
  fm_arbitrage_error_50020299: "Operation failed, please try again later",
  price_range_check_range_recommend: "The price range is too large. Please make sure you have input the correct price range.",
  price_range_check_top_recommend: "The upper price is much lower than the current price. Please check if you have omitted one digit.",
  price_range_check_bottom_recommend: "The lower price is much higher than the current price. Please check if you have input one more digit by mistake.",
  grid_pro_grid_profit: "Grid profit",
  grid_ai2_max_drop: "Maximum drawdown",
  grid_ai2_volatility: "Volatility",
  grid_ai2_smart_parameters: "Smart parameters",
  trade_grid_count: "Grids",
  grid_ai_day_type_content: "Based on {period}D backtest, suitable for running {range_1}-{range_2}D",
  grid_ai2_volatility_des: "Volatility is the degree of variation of a trading price series over a period of time. The higher the volatility, the wilder the price fluctuation.",
  grid_ai2_max_drop_desc: "A maximum drawdown is the maximum observed loss from a previous peak to a trough over a specific period. For example, the maximum drawdown in the picture below is the drop percent from point A to B.",
  trade_lower_price: "Lower limit",
  cmc_7d: "7D",
  cmc_30d: "30D",
  day_180: "180D",
  twap_fix_number_mode_desc: "Buy/Sell for limited times and stop automatically",
  dca_switch_symbol_button: "Switch to {base}/{quote}",
  dca_switch_symbol_tip_2: "Only {quote} pairs are supported in TWAP(Perpetual mode).",
  dca_switch_symbol_tip_1: "You can only create TWAP(Perpetual mode) bots with {quote}. To DCA buy {base}, please switch to {base}/{quote}.",
  drawer_leverage_select_symbol: "Switch pair",
  twap_perpetual_mode_desc: "Regular buying until you stop it",
  twap_perpetual_mode: "Perpetual mode",
  twap_fix_number_mode: "Limited mode",
  fsa_change_old_swap_key_error_title: "Please stop the running Arbitrage Bots first",
  fsa_change_old_swap_key_error_content: "Due to the system update. You need to stop the running Arbitrage Bots first and then can create a new one.",
  trade_error_input_invest: "Please input investment.",
  martingale_error_stop_profit_percentage_min: "Stop loss percentage should ＞{min}",
  moon_grid_order_create: "Create {base}/{quote} Bot ",
  trade_please_set_myself: "Please set myself",
  grid_set_spl_delay_value_error_1: "Delay time (Required≥5)",
  //Should be very short
  grid_set_spl_delay_value_error_2: "Delay time (Required≤30)",
  //Should be very short
  grid_bullish_take_profit_error_1: "Take profit price should be above the higher limit",
  grid_bullish_take_profit_error_2: "Take profit price should be above the current price",
  grid_bullish_take_profit_error_3: "Take profit price should be above the trigger price",
  grid_bullish_stop_loss_error_1: "Stop loss price should be below the lower limit",
  grid_bullish_stop_loss_error_2: "Stop loss price should be below the current price",
  grid_bullish_stop_loss_error_3: "Stop loss price should be below the trigger price",
  grid_bullish_take_profit_error_4: "Take profit price should be below the current price",
  grid_bullish_take_profit_error_5: "Take profit price should be below the trigger price",
  grid_bullish_stop_loss_error_4: "Stop loss price should be above the current price",
  grid_bullish_stop_loss_error_5: "Stop loss price should be above the trigger price",
  tip_moon_bot_param: "Current: {bottom}-{top}, {count} grids",
  trade_input_buy_price_fist_please: "Please input buy price",
  save: "Save",
  mrt_trading_multi_title_des: "Share funds among multiple coins",
  mrt_trading_single_title_des: "Simplified settings, arbitrage with one coin",
  mrt_trading_single_title: "Simple mode",
  mrt_trading_multi_title: "Composite mode",
  mtg_max_active_safety_orders: "Max active safety orders",
  mtg_max_active_coins: "Max active coins",
  martingale_signal_immediately: "Immediately",
  trade_signal: "Signal",
  mtg_multi_coins_selected: "{count} coins selected",
  mtg_max_active_safety_orders_tip: "The number of safety orders the bot is allowed to place in advance on the exchange's order book for each coin. The higher the number, the higher the min investment amount needed. The lower the number, the higher probability of insufficient funds when running.",
  mtg_max_active_coins_tip: 'How many coins the bot may arbitrage at the same time. Not editable when the signal is set to "Immediately" or "Time-lapse".',
  martingale_max_active_try_edit_forbidden: 'Not editable. The signal is "Immediately" or "Time-lapse"',
  martingale_max_active_safet_order_zero_error: "Max active safety order cannot be 0",
  martingale_max_active_safet_order_error: "Max active safety order must be less than or equal to the number of safety orders",
  martingale_max_active_coins_error: 'Not editable. Because the signal is "Immediately" or "Time-lapse"',
  martingale_coin_select_not_enough_error: "Please select at least two coins",
  trade_adv_setting_signal: "Signal",
  trade_input_param_please: "Please input {param}",
  martingale_DIY_shares: "Shares",
  martingale_signal_immediately_desc: "A new round will start immediately after the former round has ended",
  martingale_signal_time_lapse_desc: "A new round will start after a fixed time interval. e.g. If you set 5 seconds, after a round has ended，a new round will start 5 seconds later",
  martingale_signal_time_lapse: "Time-lapse",
  martingale_DIY_tutorial_title: "How to set the parameters?",
  martingale_DIY_tutorial_desc: "#: How many times your bot will buy in a single round.\n\nPrice deviation: The percentage the bot will place the orders away from the last buy order.\n\nShares: How much you want to invest in the specific order. The bot will place orders proportionally according to your total investment.",
  martingale_DIY_total_shares: "Total shares",
  martingale_DIY_total_shares_desc: "The bot will evenly divide investment into several parts to buy the dips in each round. The total value bought in the buy order=Investment * Share/Total shares",
  martingale_DIY_error_shares_exceed: "You can't add more orders when total shares are greater than {max}.",
  martingale_DIY_error_orders_exceed: "You can't add more than {max} orders",
  martingale_DIY_error_delete_on_min: "You can't cancel the initial order.",
  mtg_custom_mode: "DIY",
  martingale_DIY_book_menu_title: "My favorites",
  martingale_DIY_book_menu_save: "Save this setting",
  martingale_DIY_book_menu_read: "Saved settings",
  martingale_DIY_book_name_placeholder: "Name (≤{max} characters)",
  order_fav_params_save_success: "Saved",
  order_fav_params_save_error: "Failed: {error}",
  order_fav_params_list_read_error: "Failed to duplicate the saved settings: {error}",
  apply_button: "Apply",
  martingale_warning_delete_DIY_book: "Are you sure you want to delete this saved setting?",
  martingale_delete_DIY_error: "Failed to delete: {error}",
  martingale_delete_DIY_success: "Deleted",
  add_item_button: "Add",
  favourite_item_button: "Favourite",
  martingale_DIY_max_drawback: "Max drawback",
  martingale_DIY_max_drawback_desc: "The last safety order will be filled when the price drop reaches this ratio compared to the first order.",
  error_martingale_DIY_price_scale_length_low: "At least 2 orders are needed.",
  martingale_DIY_book_menu_save_error_same: "Name used, please rename the settings.",
  number_row_title: "#",
  martingale_shares_unit: "share(s)",
  martingale_DIY_book_name: "Name",
  martingale_renew_warning_title: "Double confirmation",
  martingale_DIY_setting_book_empty: "You have no saved settings",
  martingale_DIY_check: "Check",
  martingale_DIY_apply: "Apply",
  mtg_multi_edit_coins: "Edit",
  martingale_DIY_error_shares_max: "Required ≤ {max}",
  martingale_DIY_error_shares_max_desc: "Total shares are greater than {max}.",
  martingale_error_stop_price_upper_need_more_than_lower_short: "Require<upper price",
  martingale_error_stop_price_upper_need_more_than_lower: "The stop opening upper price should higher than the lower price.",
  profit_allocation_others: "Others",
  please_choose_symbol_quote: "Please select  {quote} pairs",
  unlimited: "All Results",
  invest_quote: "{quote} pairs",
  confirm_clear_selected_currency: "Do you want to delete all selected pairs?",
  clear_selected_currency: "Empty selected pairs",
  choose_pair: "Please select trading pairs",
  MTG_INSUFFICIENT_INVEST_ERROR: "Investment should>{min} due to the price fluctuation",
  //web跟单开始
  copy_feed_publish_today: "Published within 1D",
  copy_bot_list_nnt: "Copiers",
  copy_bot_list_amount: "AUM",
  copy_trade_action: "Copy",
  copy_bot_list_bot_lasting_apy: "APY since created",
  grid_v4_investment_tips: "{start} to start. The more you invest, the more grids you will get. To invest ≥{amount} can upgrade to the recommended {count} grids, and the estimated daily arbitrage is {times} times",
  grid_v4_investment_current_grid_number: "Current Girds",
  grid_v4_investment_arbitrage_times: "Estimated Daily Arbitrage",
  grid_v4_investment_grid_number: "{count} grids",
  copy_bot_enhanced_aip_buy_many_times_times: "{times} times",
  copy_bot_gridv4_swap_tips: "Hint: The invested {quote} will be swapped to {base} and invest into the bot",
  gridv4_ai_strategy: "Grid AI Strategy",
  smart_ai_strategy: "AI Strategy",
  girdv4_ai_recent_apy: "Backtested APY",
  girdv4_change_strategy: "Change Strategy",
  girdv4_ai_source: "Strategy Source",
  girdv4_manual_edit: "Manually Edit Parameter",
  girdv4_copy_apr: "Strategy APY",
  copy_feed_run_day: "Running {day} Days",
  copy_order_closed: "The order is closed",
  //web跟单结束
  unsupported_signal: "{signal} is temporarily not supported",
  use_signal_remove_pair: "Remove the following coins to use {signal}",
  selected_pair_unsupported: "Temporarily not supported",
  copy_bot_list_bot_coin_lasting_roi: "Profit in {coin}",
  grid_trading_component_deposit: "Deposit",
  grid_trading_component_transfer: "Transfer",
  grid_futures_disable_symbol: "Futures grid is not supported yet",
  //中性网格止盈
  trade_no_trend_tp_price_placeholder: "Enter Take Profit Arbitrage Rounds (≥{trx})",
  trade_no_trend_tp_price_error: "Take Profit Arbitrage needs {trx} rounds",
  trade_no_trend_tp_trx_label: "Current arbitrage rounds",
  trade_no_trend_tp_trx_value: "{num} rounds",
  trade_no_trend_tp_set_desc: "Arbitrage {times} rounds, no positions",
  trade_no_trend_tp_profit_label: "Estimated Profits (Take Profit)",
  trade_no_trend_tp_desc: "At {times} rounds of arbitrage with no position (estimated price {price1}~{price2}), system clears position at market price, returning all assets to main account.",
  trade_no_trend_tp_desc_delay: "At {times} rounds of arbitrage with no position (expected price {price1}~{price2}), triggers grid strategy's {delay}s countdown. When it ends and conditions still met, bot closes order, returning assets to main account.",
  trade_no_trend_tp_tips: "Take profit returns to the start price, with no gains or losses held when price retraces. Set the arbitrage rounds to maximize profit during take profit.",
  trade_no_trend_tp_params_check: "Set grid parameters and investment first",
  grid_spl_set_deny_by_range_none: "Please set the price range first",
  min_amount_coin: "Min amount {amount}",
  max_buy_amount_coin: "Max amount {amount}",
  max_sell_amount_coin: "Max amount {amount}",
  min_required_volume: "Min amount {cost}",
  number_input_exceed_desc: "The number entered is too large, please re-enter",
  quantity_is_for_reference_only: "The quantity is for reference only, and the system will place the order based on the trading volume",
  volume_is_for_reference_only: "The trading volume is for reference only, and the system will place the order based on the quantity",
  estimated_commission: "Est. Transaction Fee",
  max_amount_coin: "Max {amount}",
  max_required_volume: "Max {cost}",
  //币币合约网格按U开单
  grid_futures_usdt_for_btc_tips: "Tip: The invested {quote} will be swapped for {base} before being put into the bot",
  grid_futures_usdt_for_btc_warning_msg: "Tip: Due to price fluctuations, the amount of {quote} swapped for {base} may vary slightly",
  estimated_purchase_quantity: "Est. Qty",
  estimated_transaction_volume: "Est. Volume",
  enhance_aip_add_invest_bottom_times: "The balance could invest up to",
  create_the_bot: "Create the bot",
  copy_bot_enhanced_aip_investment_item_title: "Amount per {duration}",
  buy_and_staking: "Buy & Stake (Flexible)",
  copy_enhance_aip_over_price: "Price limit",
  bot_enhanced_aip_tips: "Please note: The bot will buy coins worth {amount}{token} immediately and repeat buying every {time}.",
  gird_open_confirm_reserved: "Reserved",
  maker_adjust_purchase_price: "The post-only order isn't able to match immediately with the order book. Please revise the buy price.",
  maker_adjust_selling_price: "The post-only order isn't able to match immediately with the order book. Please revise the sell price.",
  maker_buying_price_is_higher: "Since the buy price is higher than order book price, the order will be filled at <style>market price</style>. Would you like to proceed?",
  maker_selling_price_is_higher: "Since the sell price is lower than the order book price, the order will be filled at <style>market price</style>. Would you like to proceed?",
  maker_separate_buy_price: "The post-only order isn't able to match immediately with the order book. Please revise the upper and lower limit price.",
  maker_separate_buy_price_confirm: "Since the lower limit buy price is greater than the order book price, all the Grid Orders will be filled at <style>market price</style>. Would you like to proceed?",
  maker_separate_upper_price: "The post-only order isn't able to match immediately with the order book. Please revise the upper limit price.",
  maker_separate_upper_price_confirm: "Since the upper limit buy price is greater than the order book price, part of the Grid Orders will be filled at <style>market price</style>. Would you like to proceed?",
  maker_separate_sell_price: "The post-only order isn't able to match immediately with the order book. Please revise the upper and lower limit price.",
  maker_separate_sell_price_confirm: "Since the upper limit sell price is lower than the order book price, all the Grid Orders will be filled at <style>market price</style>. Would you like to proceed?",
  maker_separate_sell_lower_price: "The post-only order isn't able to match immediately with the order book. Please revise the lower limit price.",
  maker_separate_sell_lower_price_confirm: "Since the lower limit sell price is lower than the order book price, part of the Grid Orders will be filled at <style>market price</style>. Would you like to proceed?",
  price_confirmation: "Price Confirmation",
  input_min_max_price_tip: "Please fill in the lower limit and upper limit",
  min_need_less_max_price_tip: "The lower limit should be less than the upper limit",
  input_grid_tip: "Please fill in the Grids",
  leverage_coin_not_maker: "Not support maker only orders yet",
  grid_v5_top_price_limit: "The highest price should be lower than {limit}",
  grid_v5_bottom_price_limit: "The lowest price should be higher than {limit}",
  copied_pair_bot: "Copied {base}/{quote} Bot"
};